<template>
  <teleport to="body">
    <div
      ref="panel"
      class="fixed outline-none z-[9999] cursor-pointer"
      :class="{ 'invisible pointer-events-none': !positioned }"
      :style="style"
      tabindex="0"
      @blur="$emit('close')"
    >
      <slot />
    </div>
  </teleport>
</template>
<script>
const VIEWPORT_MARGIN = 4;

export default {
  props: {
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      left: this.x,
      top: this.y,
      positioned: false,
    };
  },
  computed: {
    style() {
      return {
        top: `${this.top}px`,
        left: `${this.left}px`,
      };
    },
  },
  watch: {
    x() {
      this.syncFromProps();
      this.$nextTick(() => {
        this.adjustPosition();
      });
    },
    y() {
      this.syncFromProps();
      this.$nextTick(() => {
        this.adjustPosition();
      });
    },
  },
  mounted() {
    this.syncFromProps();
    this.$nextTick(() => {
      this.adjustPosition();
      this.positioned = true;
      this.$nextTick(() => {
        const panel = this.$refs.panel;
        if (panel) panel.focus();
      });
    });
  },
  methods: {
    syncFromProps() {
      this.left = this.x;
      this.top = this.y;
    },
    adjustPosition() {
      const el = this.$refs.panel;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const margin = VIEWPORT_MARGIN;
      let { left } = this;
      let { top } = this;

      if (rect.bottom > window.innerHeight - margin) {
        top = this.y - rect.height;
      }
      if (top < margin) {
        top = margin;
      }
      if (rect.right > window.innerWidth - margin) {
        left = window.innerWidth - rect.width - margin;
      }
      if (left < margin) {
        left = margin;
      }

      this.left = left;
      this.top = top;
    },
  },
};
</script>
